export const ModelingStatus = {
  Modified: 1,
  Applying: 2,
  Applied: 3,
  "Processing Data": 4,
  Error: 5,
};
